import React from 'react';
import '@/assets/styles/Button.module.less';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({ children, className, ...rest }) => {
  return (
    <button className={`common-button ${className || ''}`} {...rest}>
      {children}
    </button>
  );
};

export default Button;
